export enum HeadersValues {
    ACCEPT_ERROR = 'application/vnd.hilllabs.error.v1+json',
    ACCEPT_FAVOURITE = 'application/vnd.hilllabs.favourite.v1+json'
}

export enum HeaderKey {
    ACCEPT = 'Accept',
    AUTHORIZATION = 'Authorization'
}

export enum FavouriteTypes {
    ANALYTICAL_TEST = 'ANALYTICAL_TEST',
    SAMPLING_ITEM = 'SAMPLING_ITEM',
    CONTAINER = 'CONTAINER'
}

export type SamplingSupplyFavouriteTypes = FavouriteTypes.SAMPLING_ITEM | FavouriteTypes.CONTAINER;
